import {
  Button,
  IconAdd20,
  IconPencil20,
} from '@lightspeed/unified-components-helios-theme/react'
import React from 'react'
import { SaleAddressModal } from '../SaleAddressModal'
import type { EditAddressButtonProps } from './EditAddressButton.type'
import { useEditAddressButtonModel } from './useEditAddressButtonModel'

export const AddOrEditAddressButton: React.FC<EditAddressButtonProps> = props => {
  const model = useEditAddressButtonModel(props)

  if (model.isDisabled) {
    return null
  }

  return (
    <div className="uc-base">
      <Button
        aria-label={model.ariaLabel}
        appearance={model.appearance}
        customDataAttributes={{ container: { 'data-track': model.dataTrack } }}
        onClick={model.handleClick}
        prefixSlot={
          model.isAddType ? (
            <IconAdd20 aria-hidden />
          ) : (
            <IconPencil20 aria-hidden />
          )
        }
        size="medium"
        type="button"
      >
        {props.text || (model.isAddType ? model.addAddressLabel : null)}
      </Button>

      {!model.isAddressModalRefactorEnabled && model.showSaleAddressModal && (
        <SaleAddressModal
          formType={props.type}
          fulfillmentDetails={model.fulfilmentDetails}
          onClose={model.handleModalClose}
          onSave={model.handleModalSave}
        />
      )}
    </div>
  )
}
